import React from "react";

const Star = ({
  top,
  left,
  right,
  bottom,
  startColor,
  stopColor,
  gradientName,
  size,
  fill,
  color,
  zIndex,
}) => {
  const style = {
    top: `${top}px`,
    left: `${left}px`,
    bottom: `${bottom}px`,
    right: `${right}px`,
    width: `${size}px`,
    height: `${size}px`,
    zIndex: zIndex,
    position: "absolute",
  };
  if (fill == false) {
    return (
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={style}
        // className="spinner-clockwise"
        className="spinner-counterClockwise"

      >
        <path
          d="M20.8326 3.3748C24.8189 1.46959 28.9143 5.77843 26.8091 9.66285C25.6613 11.7809 26.0078 14.3972 27.6675 16.1434C30.7113 19.3458 27.8789 24.5723 23.5341 23.7705C21.165 23.3334 18.7838 24.4714 17.636 26.5895C15.5309 30.4739 9.68497 29.3952 9.10483 25.0153C8.7885 22.627 6.97033 20.7141 4.60124 20.2769C0.25642 19.4752 -0.524148 13.5821 3.46213 11.6769C5.63572 10.638 6.89318 8.31772 6.57685 5.92949C5.99671 1.54958 11.3602 -1.01386 14.404 2.18856C16.0637 3.93475 18.659 4.41365 20.8326 3.3748Z"
          stroke="#FFA8D8"
        />
      </svg>
    );
  }
  if (color == "white") {
   return <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}

    >
      <path
        d="M17.8482 5.72606C18.8126 5.26513 19.8034 6.30756 19.2941 7.24731C17.8279 9.95291 18.2705 13.295 20.3906 15.5255C21.127 16.3003 20.4417 17.5647 19.3906 17.3708C16.3643 16.8123 13.3226 18.2661 11.8564 20.9717C11.3471 21.9114 9.93281 21.6505 9.79246 20.5908C9.38838 17.5401 7.06585 15.0965 4.03957 14.5381C2.98844 14.3442 2.7996 12.9184 3.76399 12.4575C6.54053 11.1305 8.14681 8.16652 7.74273 5.1158L4.76871 5.50971L7.74273 5.11579C7.60238 4.05618 8.89996 3.43601 9.63633 4.21076C11.7564 6.44134 15.0717 7.05309 17.8482 5.72606Z"
        stroke="white"
        stroke-width="6"
      />
    </svg>;
  }
  if (color == "blue") {
    return (
      <svg
        width="121"
        height="123"
        viewBox="0 0 121 123"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={style}
      >
        <path
          d="M30.1793 12.8742C28.8885 2.29669 41.8871 -3.75298 49.1487 4.04567L64.3631 20.3853C67.6106 23.873 72.7345 24.8729 77.0549 22.8621L97.2964 13.4416C106.957 8.94538 116.728 19.4384 111.555 28.7545L100.716 48.2734C98.4028 52.4397 99.0352 57.6218 102.283 61.1095L117.497 77.4491C124.759 85.2478 117.798 97.7825 107.34 95.7415L85.4268 91.4652C80.7495 90.5525 76.0165 92.7553 73.703 96.9215L62.8646 116.44C57.6916 125.757 43.6196 123.01 42.3288 112.433L39.6243 90.2711C39.047 85.5407 35.4894 81.72 30.8122 80.8073L8.89927 76.531C-1.55939 74.49 -3.29616 60.2581 6.36474 55.7618L26.6062 46.3413C30.9267 44.3305 33.461 39.7664 32.8837 35.036L30.1793 12.8742Z"
          fill="url(#paint0_linear_127_354)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_127_354"
            x1="-52.986"
            y1="-0.820716"
            x2="100.616"
            y2="139.426"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#93FFC3" />
            <stop offset="1" stop-color="#A0CEF3" />
          </linearGradient>
        </defs>
      </svg>
    );
  }
  return (
    <svg
      width="69"
      height="67"
      viewBox="0 0 69 67"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M11.8694 12.2633C9.65272 3.24047 20.2772 -3.34741 27.3743 2.6493L30.9587 5.67804C34.1326 8.35985 38.6724 8.69304 42.2038 6.50335L46.1917 4.03062C54.0882 -0.865733 63.6372 7.20303 60.1268 15.8056L58.3542 20.1495C56.7843 23.9968 57.8704 28.4173 61.0443 31.0992L64.6283 34.1275C71.7253 40.1242 67.0024 51.6989 57.736 51.0189L53.0556 50.6754C48.9116 50.3713 45.0431 52.77 43.4732 56.6171L41.7002 60.9621C38.1899 69.5646 25.7219 68.6493 23.5052 59.6265L22.3858 55.07C21.3945 51.0348 17.9174 48.0968 13.7733 47.7926L9.09404 47.4492C-0.172516 46.7692 -3.15523 34.6289 4.74129 29.7325L8.72915 27.2598C12.2605 25.0701 13.9803 20.8556 12.989 16.8205L11.8694 12.2633Z"
        fill={`url(#${gradientName})`}
      />
      <defs>
        <linearGradient
          id={`${gradientName}`}
          x1="-44.0253"
          y1="2.32976"
          x2="75.3263"
          y2="102.932"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.291406" stop-color={startColor} />
          <stop offset="1" stop-color={stopColor} />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Star;
